import fetch from '@/plugins/axios'
import { Commit } from 'vuex'
export default {
	namespaced: true,
	state: {
        mailList: [], //寄件列表
        mailPager: {},
        deliveryList: [], //派件列表
		deliveryPager: {},
		smsList: [],
		smsPager: {},
		loading: false,
		shelves: [],
	},
	mutations: {
		setState(state:any, { key, data }: {key:string;data:object}) {
			state[key] = data;
		}
	},
	actions: {
		// 查询寄件列表
		async getMailList({ commit }:{commit:Commit}, params: object) {
            commit('setState',{key:'loading',data: true})
			const res: any = await fetch({
                url: '/admin/delivery',
                params
			})
            commit('setState', { key: 'mailList', data: res.docs })
            commit('setState',{key:'mailPager',data: {limit: res.limit,total: res.total,sizes: 600}})
            commit('setState',{key:'loading',data: false})
        },
        // 查询派件列表
		async getDeliveryList({ commit }: any, params: any) {
            commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/admin/packages',
                params
			})
			res.docs.forEach((item:any) => {
				item.intime = item.intime.split('-')[1]+'-'+item.intime.split('-')[2].split(':')[0]+':'+item.intime.split('-')[2].split(':')[1];
				item.outtime = item.outtime ? (item.outtime.split('-')[1]+'-'+item.outtime.split('-')[2].split(':')[0]+':'+item.outtime.split('-')[2].split(':')[1]) : '';
			})
            commit('setState', { key: 'deliveryList', data: res.docs })
            commit('setState',{key:'deliveryPager',data: {limit: res.limit,total: res.total}})
            commit('setState',{key:'loading',data: false})
		},
		async getSmsList({ commit }: { commit: Commit }, params: object) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
				url: '/admin/sms',
				params
			})
			commit('setState',{key: 'smsList',data: res.docs})
			commit('setState',{key:'smsPager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
		},
		// 导入派件列表
		async importDeliveryFun({ commit }: any, params: any){
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
				url: 'admin/packagesimport',
				method: 'get',
				params 
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 通过快递单号查询
		async getCodeInfo({ commit }: any, id: string) {
			return await fetch({
				url: `/admin/packages/${id}`
			})
		},
		// 入站
		async inboundPachages({ commit }: any, params:any) {
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
				url: `/common/uploadLogicInfoAgain/${params.id}/${params.type}`,
				method: 'put'
			})
			commit('setState',{key:'loading',data: false})
			return res
		},
		// 获取货架
		async getShelves({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res = await fetch({
				url: '/admin/shelf',
				params
			})
			commit('setState',{key: 'shelves',data: res})
			commit('setState',{key:'loading',data: false})
		},
		// 添加货架
		async addShelves({ dispatch,commit }: any, params: any) {
			const res = await fetch({
				url: '/admin/shelf',
				method: 'post',
				data: params
			})
			// dispatch('getShelves')
			return res
		},
		// 删除货架
		async deletShelves({ dispatch,commit }: any, id: any) {
			const res = await fetch({
				url: `/admin/shelf/${id}`,
				method: 'delete'
			})
			// dispatch('getShelves')
			return res
		},
		// 修改货架
		async modifyShelves({ dispatch,commit }: any, params: any) {
			const res = await fetch({
				url: `/admin/shelf/${params.id}`,
				method: 'put',
				data: params.data
			})
			// dispatch('getShelves')
			return res
		},
		// 恢复删除货架
		async restoreShelves({ dispatch,commit }: any, id: string) {
			const res = await fetch({
				url: `/admin/shelf/${id}/enabled`,
				method: 'put'
			})
			return res
		},
	}
}